<header class="content-header">
  @if (sidebar.search.query || sidebar.search.searchMode === 'basic') {
    <h4 class="vision-h4">Basic Search</h4>
  }
  @if (sidebar.search.searchMode === 'advanced') {
    <h4 class="vision-h4">Advanced Search</h4>
  }
</header>

@if (displayStatusWarning$ | async) {
  <fw-alert
    icon="warning"
    [description]="searchStatusMessage$ | async"
    [severity]="(searchStatus$ | async) === 'error' ? 'error' : 'warning'"
  />
}

@let counts = searchResultCounts$ | async;

<mat-tab-group
  animationDuration="0ms"
  class="tabs-white content-body"
  mat-stretch-tabs="false"
  (selectedTabChange)="changeTab($event)"
  [(selectedIndex)]="tabIndex"
>
  <!-- Subjects -->
  <mat-tab label="Subjects {{ counts.subject }}" test-id="subject-header-tab">
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="results" />
    </ng-template>
  </mat-tab>

  <!-- Sessions -->
  <mat-tab label="Sessions {{ counts.session }}" test-id="session-header-tab">
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="results" />
    </ng-template>
  </mat-tab>

  <!-- Acquisitions -->
  <mat-tab label="Acquisitions {{ counts.acquisition }}" test-id="acquistion-header-tab">
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="results" />
    </ng-template>
  </mat-tab>

  <!-- Files -->
  <mat-tab label="Files {{ counts.file }}" test-id="file-header-tab">
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="results" />
    </ng-template>
  </mat-tab>

  <!-- Analyses -->
  <mat-tab label="Analyses {{ counts.analysis }}" test-id="analysis-header-tab">
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="results" />
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #results>
  <div class="tools">
    <!-- Actions -->
    <span class="actions-section">
      <button class="action-button" mat-button test-id="search-action-button" [matMenuTriggerFor]="actionMenu">
        Actions
        <mat-icon class="xs" iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        @if (availableActions$ | async; as actions) {
          @if (actions.downloadFiles.visible) {
            <div
              fwTooltipPosition="right"
              [fwTooltip]="actions.downloadFiles.disabled ? actions.downloadFiles.tooltip : null"
            >
              <button
                mat-menu-item
                test-id="search-action-download-files"
                [disabled]="actions.downloadFiles.disabled"
                (click)="downloadFiles()"
              >
                Download
              </button>
            </div>
          }
          <div fwTooltipPosition="right" [fwTooltip]="actions.modifyTags.disabled ? actions.modifyTags.tooltip : null">
            <button
              mat-menu-item
              test-id="search-action-modify-tags"
              [disabled]="actions.modifyTags.disabled"
              (click)="modifyTags()"
            >
              Modify Tags
            </button>
          </div>
          @if (actions.addToCollection.visible) {
            <div
              fwTooltipPosition="right"
              [fwTooltip]="actions.addToCollection.disabled ? actions.addToCollection.tooltip : null"
            >
              <button
                mat-menu-item
                test-id="search-action-add-to-collection"
                [disabled]="actions.addToCollection.disabled"
                (click)="addToCollection()"
              >
                {{ 'Add to Collection' }}
              </button>
            </div>
          }
          @if (actions.runGear.visible) {
            <div fwTooltipPosition="right" [fwTooltip]="actions.runGear.disabled ? actions.runGear.tooltip : null">
              <button
                mat-menu-item
                test-id="search-action-run-gear"
                [disabled]="actions.runGear.disabled"
                (click)="runBatchGear()"
              >
                Run Batch Gear
              </button>
            </div>
          }
          @if (actions.deleteContainers.visible) {
            <mat-divider />
          }
          @if (actions.deleteContainers.visible) {
            <div
              fwTooltipPosition="right"
              [fwTooltip]="actions.deleteContainers.disabled ? actions.deleteContainers.tooltip : null"
            >
              <button
                mat-menu-item
                test-id="search-action-delete-containers"
                [disabled]="actions.deleteContainers.disabled"
                (click)="deleteContainers()"
              >
                Delete Data
              </button>
            </div>
          }
          @if (actions.moveContainers.visible) {
            <mat-divider />
          }
          @if (actions.moveContainers.visible) {
            <div
              fwTooltipPosition="right"
              [fwTooltip]="actions.moveContainers.disabled ? actions.moveContainers.tooltip : null"
            >
              @if (actions.moveContainers.visible) {
                <button
                  mat-menu-item
                  test-id="search-action-move-containers"
                  [disabled]="actions.moveContainers.disabled"
                  [matMenuTriggerFor]="moveContainers"
                >
                  Move Sessions to
                </button>
              }
            </div>
          }
          <mat-menu #moveContainers="matMenu">
            <button
              mat-menu-item
              test-id="search-action-move-to-project"
              [disabled]="actions.moveContainers.disabled"
              (click)="moveSessionsToProject()"
            >
              {{ 'Project' }}
            </button>
            <button
              mat-menu-item
              test-id="search-action-move-to-subject"
              [disabled]="actions.moveContainers.disabled"
              (click)="moveSessionsToSubject()"
            >
              {{ 'Subject' }}
            </button>
          </mat-menu>
          @if (actions.createTrainingSet.visible) {
            <div
              fwTooltipPosition="right"
              [fwTooltip]="actions.createTrainingSet.disabled ? actions.createTrainingSet.tooltip : null"
            >
              <button
                mat-menu-item
                test-id="search-action-create-training-set"
                [disabled]="actions.createTrainingSet.disabled"
                (click)="createTrainingSet()"
              >
                Create ML Data Training Set
              </button>
            </div>
          }
        }
      </mat-menu>
      <mat-checkbox style="margin-left: 5px" test-id="check-truncate" [(ngModel)]="truncateText">
        Single Line Rows
      </mat-checkbox>
    </span>

    <span class="export-pagination-section">
      <div [fwTooltip]="downloadTooltipMessage">
        <button
          class="export-csv-button"
          mat-button
          test-id="export-csv-button"
          [disabled]="downloadIsDisabled || downloading"
          (click)="exportCSV()"
        >
          <mat-icon class="xs">download</mat-icon>
          {{ exportCsvLabel }}
        </button>
        @if (downloading) {
          <mat-spinner [diameter]="16" />
        }
      </div>

      <!-- Pagination -->
      <button class="pagination-button" mat-button test-id="search-pagination-button" [matMenuTriggerFor]="pageMenu">
        Showing {{ page?.size }} of {{ page?.total }}
        <mat-icon class="xs" iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #pageMenu="matMenu">
        <button mat-menu-item test-id="search-pagination-100" (click)="changePageSize(100)">100</button>
        <button mat-menu-item test-id="search-pagination-250" (click)="changePageSize(250)">250</button>
        <button mat-menu-item test-id="search-pagination-500" (click)="changePageSize(500)">500</button>
        <button mat-menu-item test-id="search-pagination-1000" (click)="changePageSize(1000)">1000</button>
      </mat-menu>
    </span>
  </div>

  <!-- Results -->
  <mat-table
    class="scroll-y"
    [class]="{ 'single-line-row': truncateText }"
    [dataSource]="searchResults$"
    [trackBy]="getResultRowId"
  >
    <!-- Checks -->
    <ng-container matColumnDef="checkbox">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox test-id="search-check-all" [checked]="allChecked$ | async" (change)="checkAllRows()" />
      </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
        <mat-checkbox
          test-id="check-result"
          [checked]="(checkedResultIds$ | async)?.has(element._id)"
          (change)="checkResultRow(element)"
        />
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="extendChecked">
      <mat-header-cell *matHeaderCellDef class="check-all-cell" [attr.colspan]="10">
        <span
          >You've selected <strong>{{ page?.checked }}</strong> out of <strong>{{ page?.total }}</strong> results.</span
        >
        <a test-id="search-extend-checked" (click)="extendCheckedRows()">Select all results</a>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="allChecked">
      <mat-header-cell *matHeaderCellDef class="check-all-cell" [attr.colspan]="10">
        <span
          >You've selected all <strong>{{ page?.checked }}</strong> results.</span
        >
      </mat-header-cell>
    </ng-container>

    <!-- Loading -->
    <ng-container matColumnDef="loadingIndicator">
      <mat-header-cell *matHeaderCellDef class="fw-ghost-animation" [attr.colspan]="10">
        <span>Loading...</span>
      </mat-header-cell>
    </ng-container>

    <!-- Filters -->
    <ng-container matColumnDef="hierarchy">
      <mat-header-cell *matHeaderCellDef #hierarchyHeaderCell>
        @if (searchFilters.get('hierarchy'); as control) {
          <div>
            <span>Hierarchy</span>
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="hierarchy" [fwTooltip]="hierarchyMap.get(element)?.pretty">
        {{ truncateText ? hierarchyMap.get(element)?.short : hierarchyMap.get(element)?.pretty }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionTimestamp">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('sessionTimestamp'); as control) {
          <div>
            @if (!control.value) {
              <mat-datepicker-toggle class="xs" test-id="session-timestamp-toggle" [for]="sessionTimestampDatepicker">
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Timestamp"
              test-id="session-timestamp-filter"
              type="text"
              [formControl]="$any(control)"
              [matDatepicker]="sessionTimestampDatepicker"
              (click)="sessionTimestampDatepicker.open()"
            />
            <mat-datepicker #sessionTimestampDatepicker />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="session-timestamp">{{
        element._source.session?.timestamp | date: 'yyyy-MM-dd HH:mm'
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionAge">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('sessionAge'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Age"
              test-id="session-age-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="session-age">
        {{ ageInYears(element._source.session?.age) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionLabel">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('sessionLabel'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Label"
              test-id="session-label-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div class="ellipsis-clamp-2" test-id="session-label" [fwTooltip]="element._source.session?.label">
          {{ element._source.session?.label }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sessionModality">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('sessionModality'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Modality"
              test-id="session-modality-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div class="ellipsis-clamp-2" test-id="session-modality" [fwTooltip]="element._source.session?.modality">
          {{ element._source.session?.file_modalities?.join(', ') }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectTimestamp">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('subjectTimestamp'); as control) {
          <div>
            @if (!control.value) {
              <mat-datepicker-toggle class="xs" test-id="subject-timestamp-toggle" [for]="subjectTimestampDatepicker">
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Timestamp"
              test-id="subject-timestamp-filter"
              type="text"
              [formControl]="$any(control)"
              [matDatepicker]="subjectTimestampDatepicker"
              (click)="subjectTimestampDatepicker.open()"
            />
            <mat-datepicker #subjectTimestampDatepicker test-id="subject-timestamp-picker" />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="subject-timestamp">{{
        element._source.subject?.created | date: 'yyyy-MM-dd HH:mm'
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectCode">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('subjectCode'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Subject"
              test-id="subject-code-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div class="ellipsis-clamp-2" test-id="subject-code" [fwTooltip]="element._source.subject?.code">
          {{ element._source.subject?.code }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectSex">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('subjectSex'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Sex"
              test-id="subject-sex-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div class="ellipsis-clamp-2" test-id="subject-sex" [fwTooltip]="element._source.subject?.sex">
          {{ element._source.subject?.sex | titlecase }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectCohort">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('subjectCohort'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Cohort"
              test-id="subject-cohort-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div class="ellipsis-clamp-2" test-id="subject-sex" [fwTooltip]="element._source.subject?.cohort">
          {{ element._source.subject?.cohort }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subjectMlSet">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('subjectMlSet'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="ML Set"
              test-id="subject-ml-set-input"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div class="ellipsis-clamp-2" test-id="subject-ml-set" [fwTooltip]="element._source.subject?.mlset">
          {{ element._source.subject?.mlset }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="acquisitionTimestamp">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('acquisitionTimestamp'); as control) {
          <div>
            @if (!control.value) {
              <mat-datepicker-toggle
                class="xs"
                test-id="acquisition-timestamp-toggle"
                [for]="acquisitionTimestampDatepicker"
              >
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Timestamp"
              test-id="acquisition-timestamp-filter"
              type="text"
              [formControl]="$any(control)"
              [matDatepicker]="acquisitionTimestampDatepicker"
              (click)="acquisitionTimestampDatepicker.open()"
            />
            <mat-datepicker #acquisitionTimestampDatepicker />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="acquisition-timestamp">{{
        element._source.acquisition?.timestamp | date: 'yyyy-MM-dd HH:mm'
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="acquisitionLabel">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('acquisitionLabel'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Label"
              test-id="acquisition-label-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2" test-id="acquisition-label" [fwTooltip]="element._source.acquisition?.label">
          {{ element._source.acquisition?.label }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="acquisitionModality">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('acquisitionModality'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Modality"
              test-id="acquisition-modality-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" mat-cell>
        <div
          class="ellipsis-clamp-2"
          test-id="acquisition-modality"
          [fwTooltip]="element._source.acquisition?.modality"
        >
          {{ element._source.acquisition?.file_modalities && element._source.acquisition?.file_modalities.join(', ') }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileTimestamp">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('fileTimestamp'); as control) {
          <div>
            @if (!control.value) {
              <mat-datepicker-toggle class="xs" test-id="file-timestamp-toggle" [for]="fileTimestampDatepicker">
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Timestamp"
              test-id="file-timestamp-filter"
              type="text"
              [formControl]="$any(control)"
              [matDatepicker]="fileTimestampDatepicker"
              (click)="fileTimestampDatepicker.open()"
            />
            <mat-datepicker #fileTimestampDatepicker />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="file-timestamp">
        {{ element._source.file?.created | date: 'yyyy-MM-dd HH:mm' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('fileName'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Name"
              test-id="file-name-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2" test-id="file-name" [fwTooltip]="element._source.file?.name">
          {{ element._source.file?.name }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileClassifications">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('fileClassifications'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Classifications"
              test-id="file-type-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2" test-id="file-type" [fwTooltip]="classificationMap.get(element)">
          {{ classificationMap.get(element) }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileContainerType">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('fileContainerType'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Level"
              test-id="file-container-type-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div
          class="ellipsis-clamp-2"
          test-id="file-container-type"
          [fwTooltip]="element._source.file?.parent_ref?.type"
        >
          {{ element._source.file?.parent_ref?.type | titlecase }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileContainerLabel">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('fileContainerLabel'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Parent Label"
              test-id="file-container-label-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div
          class="ellipsis-clamp-2"
          test-id="file-container-label"
          [fwTooltip]="element._source.file.parent_ref?.label"
        >
          {{ element._source.file.parent_ref?.label | titlecase }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileType">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('fileType'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Type"
              test-id="file-type-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="file-type">{{ element._source.file?.type }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="projectLabel">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('projectLabel'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Project"
              test-id="project-label-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="project-label">{{ element._source.project?.label }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileActions">
      <mat-header-cell *matHeaderCellDef />
      <mat-cell *matCellDef="let element" class="list-action-buttons">
        @if (element.isRendered) {
          <file-actions
            test-id="file-actions"
            [container]="element.parent"
            [file]="element._source.file"
            [kabobFeatures]="fileActionFeatures"
            (afterDelete)="filterResults()"
            (click)="$event.stopPropagation()"
          >
            <button class="xs blue" mat-icon-button test-id="file-actions-button">
              <mat-icon class="xs">more_vert</mat-icon>
            </button>
          </file-actions>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="analysisLabel">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('analysisLabel'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Label"
              test-id="analysis-label-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2" test-id="analysis-label" [fwTooltip]="element._source.analysis?.label">
          {{ element._source.analysis?.label }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="analysisTimestamp">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('analysisTimestamp'); as control) {
          <div>
            @if (!control.value) {
              <mat-datepicker-toggle class="xs" test-id="analysis-timestamp-toggle" [for]="analysisTimestampDatepicker">
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Timestamp"
              test-id="acquisition-timestamp-filter"
              type="text"
              [formControl]="$any(control)"
              [matDatepicker]="analysisTimestampDatepicker"
              (click)="analysisTimestampDatepicker.open()"
            />
            <mat-datepicker #analysisTimestampDatepicker />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element" test-id="analysis-timestamp">{{
        element._source.analysis?.created | date: 'yyyy-MM-dd HH:mm'
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="gearName">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('gearName'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Gear Name"
              test-id="gear-name-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2" test-id="gear-name" [fwTooltip]="element._source.analysis?.gear_info?.name">
          {{ element._source.analysis?.gear_info?.name }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="gearVersion">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('gearVersion'); as control) {
          <div>
            @if (!control.value) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (control.value) {
              <mat-icon class="clear-value xs" (click)="control.setValue('')">close</mat-icon>
            }
            <input
              autocomplete="off"
              placeholder="Gear Version"
              test-id="gear-name-filter"
              type="text"
              [formControl]="$any(control)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="ellipsis-clamp-2" test-id="gear-version" [fwTooltip]="element._source.analysis?.gear_info?.version">
          {{ element._source.analysis?.gear_info?.version }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tags">
      <mat-header-cell *matHeaderCellDef>
        @if (searchFilters.get('tags'); as control) {
          <div>
            @if (!areThereTags()) {
              <mat-icon class="xs">filter_alt</mat-icon>
            }
            @if (areThereTags()) {
              <mat-icon class="clear-value xs" (click)="control.setValue(emptyTagsValue)">close</mat-icon>
            }
            <tag-select-menu
              [resultType]="resultType"
              [value]="$any(control.value)"
              (valueChange)="updateTagsFilter($event)"
            />
          </div>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        <!-- we were previously colorizing these with [style]="{backgroundColor: getTagColor(chip)}" -->
        <mat-chip-set #chipList class="chip-list">
          @for (chip of getTags(element); track chip) {
            <mat-chip>
              {{ chip }}
            </mat-chip>
          }
        </mat-chip-set>

        <div
          class="chip-ellipsis"
          [style.display]="tagOverflows[i]?.hiddenItemCount > 0 ? 'block' : 'none'"
          [style.left]="tagOverflows[i]?.ellipsisOffsetLeft"
        >
          @if (tagOverflows[i]?.hiddenItemCount > 0) {
            <mat-chip class="more-chip" [fwTooltip]="tagOverflows[i]?.hiddenItemsTooltip"
              >+{{ tagOverflows[i]?.hiddenItemCount }}</mat-chip
            >
          }
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="resultColumns; sticky: true" />
    <mat-header-row
      *matHeaderRowDef="checkedStatusColumns; sticky: true"
      [class.hidden]="!((allChecked$ | async) && page?.size < page?.total) && !isLoading"
    />
    <mat-row
      *matRowDef="let row; columns: resultColumns"
      class="body-row list-action-hover"
      [attr.test-id]="'search-row-' + row._id"
      [ngClass]="{ selected: selectedResultId === row._id }"
      (click)="selectResultRow(row)"
      (mouseenter)="row.isRendered = true"
    />
  </mat-table>
</ng-template>
